<template>

    <div>

        <div class="row text-portal-soft-black">
            <div class="col" v-bind:class="messageTextHeaderStyle">
                {{cmsContentBlocks['messageBodyComponent.MessageTextHeader']}}
            </div>
            <div class="col-auto text-right" v-bind:class="{ 'text-danger': charactersLeft < 0 }">
                {{charactersLeft | toNumberWithCommas}}
            </div>
        </div>

        <div class="row">
            <div class="col warning-time-out">
                <i v-once>{{cmsContentBlocks['messageBodyComponent.InActivityWarningText']}}</i>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <banner-component v-if="nonEnglish" :bannerText="cmsContentBlocks.messageMustBeInEnglish"></banner-component>
            </div>
        </div>

        <div class="row form-group mt-2">
            <div class="col">
                <!--<banner-component v-if="nonEnglish" :bannerText="cmsContentBlocks.messageMustBeInEnglish"></banner-component>-->
                <!--capping this at 3,000 for security reasons. I don't care that 1,000 line breaks are in the text area-->
                <!--  style="background-image: none !important" =don't show the red x...give them the full space. The border is red. that is all they need -->
                <textarea ref="messageBodyRef"
                          :maxlength="maxLengthOfTextArea"
                          @input="updateModel()"
                          v-error-message="{ errorModel: 'errorModel.messageBody' }"
                          v-bind:style="textAreaStyleObject"
                          rows="5"
                          class="form-control compose-message-body"
                          style="background-image: none !important"
                          :placeholder="cmsContentBlocks['messageBodyComponent.TextAreaPlaceHolder']"
                          aria-label="Message to send"></textarea>
                <span class="invalid-feedback is-invalid">{{errorModel.messageBody | firstError}}</span>
            </div>
        </div>
    </div>

</template>

<script>

    import './message.body.scss';
    import Vue from 'vue';
    import EventBus from '../../message.event.bus';

    import errorMessageDirective from '@SharedVueComponents/Validation/ErrorMessageDirective';
    import formattingDirective from '@SharedVueComponents/formatting/formattingdirective';
    import mskBanner from '@PortalVueComponents/Banner/msk.banner.vue'

    export default {
        name: 'composeMessageBody',
        props: {
            value: { type: String },
            errorModel: { type: Object },
            textAreaStyleObject: { type: Object }, //v-bind:style="{ color: 'red'}"
            cmsContentBlocks: {},
            messageTextHeaderStyle: { type: String },
            nonEnglish: { type: Boolean }
        },
        components: {
            'banner-component': mskBanner
        },
        computed: {

            charactersLeft: function () {
                return 2000 - (this.value || '').length + this.howManyLineBreaks;
            },

            howManyLineBreaks: function () {
                return (this.value || '').split('\n').length - 1;
            },

            maxLengthOfTextArea: function () {

                let fullLengthAfterLineBreaks = 2000 + this.howManyLineBreaks;

                //hard cap after 3,000 for security purposes
                if (fullLengthAfterLineBreaks > 3000) {
                    return 2000;
                }

                return fullLengthAfterLineBreaks;
            }

        },
        methods: {

            updateModel: function () {
                EventBus.$emit('ClearError', 'messageBody');
                this.$emit('input', this.$refs.messageBodyRef.value);
            }

        }
    };
</script>

